import React from "react";
import { Shield, Layers, Grip } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const pillars = [{
  title: "Prevention",
  description: "Master the art of daily oral care to stop issues before they start. Evidence-based hygiene strategies for long-term health.",
  icon: Shield,
  href: "/KnowledgeHubPage"
}, {
  title: "Procedures",
  description: "Demystifying clinical treatments with clear, step-by-step guides. Understand what happens in the chair without the anxiety.",
  icon: Layers,
  href: "/KnowledgeHubPage"
}, {
  title: "Habits",
  description: "Building sustainable routines and debunking common dental myths. Small daily changes that create lasting impact.",
  icon: Grip,
  href: "/DentalMythsPage"
}];
export default function PathsToBetterHealth() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="paths-to-better-health" ref={ref} className="bg-background py-24 sm:py-32">
      <div className="container mx-auto px-6">
        <div className={cn("grid grid-cols-1 gap-16 md:grid-cols-3 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          {pillars.map((pillar, i) => <Card key={i} data-index={i} className="group flex flex-col justify-between border-0 bg-secondary/50 shadow-none rounded-2xl h-full transition-colors hover:bg-secondary/80">
              <CardHeader className="pt-10 px-8 pb-4">
                <div className="mb-6 text-primary/80">
                  <pillar.icon strokeWidth={1.5} className="h-10 w-10" />
                </div>
                <CardTitle className="font-serif text-3xl font-normal tracking-tight text-foreground">
                  {pillar.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="px-8 pb-8">
                <CardDescription className="text-base leading-relaxed text-muted-foreground">
                  {pillar.description}
                </CardDescription>
              </CardContent>
              <CardFooter className="px-8 pb-10 pt-0">
                <Link to={pillar.href} className="group/link inline-flex items-center text-sm font-medium text-primary transition-all">
                  Learn More
                  <span className="ml-1 block h-px w-0 bg-primary transition-all duration-300 group-hover/link:w-full" />
                </Link>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}